export default "__VITE_ASSET__DdHRNs5u__"